import React from 'react';
import { useHistory, useParams } from 'react-router-dom';
import {
  ThemeProvider, Container, Box, styled,
} from '@material-ui/core';

import { WhoAreYouEnrollingActivate } from '../WhoAreYouEnrollingActivate';

import { SleepioHeader } from '@/pages/Onboarding/components/Header/SleepioHeader';
import { Footer } from '@/pages/Onboarding/components/Footer/Footer';
import sparkTheme from '@/themes/sparkTheme';
import { EMPLOYER_ORG_SLUG_KEY } from '@/utils/constants';

const ContentContainer = styled(Box)({
  display: 'flex',
  flexDirection: 'column',
  flex: 1,
  minHeight: '100vh',
});

type Params = {
  org_slug: string;
  product: string;
};

const EmployerDependentSelectionPage: React.FC = () => {
  const history = useHistory();
  const { org_slug: orgSlug, product } = useParams<Params>();

  const storedSlug = sessionStorage.getItem(EMPLOYER_ORG_SLUG_KEY);
  if (storedSlug !== orgSlug) {
    history.replace(`/activate/${product}/employers`);
    return null;
  }

  const handleEnrollment = (type: 'myself' | 'dependent') => {
    history.push(
      `/activate/${product}/employers/${orgSlug}/dependents/create-account?enrollment=${type}`,
    );
  };

  return (
    <ThemeProvider theme={sparkTheme}>
      <ContentContainer>
        <SleepioHeader />
        <Container maxWidth="xs" style={{ flex: 1, paddingTop: 32 }}>
          <WhoAreYouEnrollingActivate
            i18nPrefix="activate.employers.person_enrolling"
            onMyself={() => handleEnrollment('myself')}
            onDependent={() => handleEnrollment('dependent')}
          />
        </Container>
        <Footer />
      </ContentContainer>
    </ThemeProvider>
  );
};

export default EmployerDependentSelectionPage;
